module.exports = __webpack_public_path__ + "static/media/1447 .655d6e98.png";